<template>
  <v-container fluid class="overview-section-wrap px-0" :class="sectionClass">
    <v-row>
      <v-col>
        <v-card class="overview-section-card" :elevation="elevation">
          <slot></slot>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'OverviewSectionCard',
  props: {
    elevation: {
      type: [Number, String],
      default: 2,
    },
    /** Extra classes on the outer v-container (e.g. spacing utilities). */
    sectionClass: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
.overview-section-card {
  border-radius: 12px;
  overflow: hidden;
}

/* Match section titles to v-card-title typography (see ProjectTodoList). */
.overview-section-card :deep(.v-card-title) {
  font-size: 1.25rem;
  font-weight: 500;
  line-height: 1.75rem;
  letter-spacing: normal;
}

.overview-section-card :deep(.overview-section-title) {
  font: inherit;
}

.overview-section-card :deep(.overview-field) {
  margin-bottom: 16px;
}

.overview-section-card :deep(.overview-field:last-child) {
  margin-bottom: 0;
}

.overview-section-card :deep(.overview-field-label) {
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.25rem;
  color: rgba(var(--v-theme-on-surface), 0.6);
  margin-bottom: 2px;
}

.overview-section-card :deep(.overview-field-value) {
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.25rem;
  color: rgba(var(--v-theme-on-surface), 0.87);
  word-break: break-word;
}
</style>
